import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import {API_TYPE, HttpHelperService} from "../../../services/http-helper.service";
import {MemberService} from "../../account/services/member.service";

@Injectable({
  providedIn: 'root'
})
export class CrmManagerService {

  constructor(
    private httpHelper: HttpHelperService,
    private memberService: MemberService,
  ) { }

  getGlobalCrmEntitiesByPersonNumber(personNumber: any) {
    return this.httpHelper.get('GetGlobalCrmEntitiesByPersonNumber', {personNumber}, API_TYPE.CRM_MANAGER_API);
  }
  searchGlobalCrmEntities(keyword: any) {
    return this.httpHelper.get('SearchGlobalCrmEntities', {keyword}, API_TYPE.CRM_MANAGER_API);
  }
  getPoAForGlobalCrmEntity(crmId: any) {
    return this.httpHelper.get('GetPoAForGlobalCrmEntity', {crmId}, API_TYPE.CRM_MANAGER_API);
  }

  deletePoAForGlobalCrmEntity(crmId: any, companyIdOverride?: any) {
    const additionalHeaders =
      companyIdOverride != null && companyIdOverride !== ''
        ? [{ key: 'companyId', value: String(companyIdOverride) }]
        : undefined;
    return this.httpHelper.delete('DeletePoAForGlobalCrmEntity', {crmId}, API_TYPE.CRM_MANAGER_API, additionalHeaders)
      .pipe(tap(() => this.memberService.clearMembershipCache()));
  }

  deletePoAForCrmEntity(crmId: any, companyIdOverride?: any) {
    const additionalHeaders =
      companyIdOverride != null && companyIdOverride !== ''
        ? [{ key: 'companyId', value: String(companyIdOverride) }]
        : undefined;
    return this.httpHelper.delete('DeletePoAForCrmEntity', {crmId}, API_TYPE.CRM_MANAGER_API, additionalHeaders)
      .pipe(tap(() => this.memberService.clearMembershipCache()));
  }

  addPoAForGlobalCrmEntity(crmId: any, powerOfAttorneyCrmId: any) {
    return this.httpHelper.post('AddPoAForGlobalCrmEntity', {crmId, powerOfAttorneyCrmId}, API_TYPE.CRM_MANAGER_API)
      .pipe(tap(() => this.memberService.clearMembershipCache()));
  }
  getGlobalCrmPoARoles(crmId: any) {
    return this.httpHelper.get('GetGlobalCrmPoARoles', {crmId}, API_TYPE.CRM_MANAGER_API);
  }

  getPowerOfAttorneyData(personNo?: any) {
    let params: any = {};
    if(personNo){
      params.personNumber = personNo;
    }
    return this.httpHelper.get('poa/GetPowerOfAttorneyData', params, API_TYPE.CRM_MANAGER_API);
  }
}
